export default __webpack_public_path__ + "static/media/photo-02.eaba424a.jpeg";